import script from "./KakaoPostModal.vue?vue&type=script&setup=true&lang=js"
export * from "./KakaoPostModal.vue?vue&type=script&setup=true&lang=js"

import "./KakaoPostModal.vue?vue&type=style&index=0&id=11813e5c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11813e5c"]])

export default __exports__